/*
 * Copyright (c) 2025 Frayo and HomeChef360. All Rights Reserved.
 *
 * CONFIDENTIAL & PROPRIETARY
 * This software and its source code are the confidential and proprietary
 * information of Frayo and HomeChef360. Unauthorized copying, modification,
 * distribution, disclosure, or use of this code, in whole or in part, via any
 * medium, is strictly prohibited without prior written consent.
 *
 * Violations will be subject to legal action in the State of Florida and may
 * also be pursued under applicable U.S. federal law.
 */

import axios from "axios";
import { getToken } from "../../../auth";
import { data } from "jquery";
//BASE_URL
const API_URL = process.env.REACT_APP_API_URL;
const API_URL_CHAT = process.env.REACT_APP_SOCKET_URL;

const listOrdersData = async (ChefId: any) => {
  const response = await axios.get(`${API_URL}list-order/${ChefId}`)
  return response.data;
};
 export const getOrderTracking = async (orderId: string) => {
  try {
    const response = await axios.get(`${API_URL}order-tracking/${orderId}`);
    return response.data; // {status, message, data: {...}}
  } catch (error) {
    console.error("Error fetching tracking:", error);
    throw error;
  }
};

const getStatus = async () => {
  const res = await axios.get(
    `${API_URL}get-order-status`
  );
  return res;
};
const changeStatusOrders = async (id: any, orderStatus: any) => {
    const res = await axios.post(`${API_URL}change-order-status/${id}`, orderStatus);
    return res.data;
};
const currentlyAvailable = async (id: any, currentlyAvailableStatus: any) => {
  const response = await axios
    .put(`${API_URL}available-chef/${id}`, currentlyAvailableStatus);
  return response.data;
};

export const getDriverMapPoints = async (orderId: string) => {
  const response = await axios.get(
    `${API_URL}driver/chef/map-points`,
    {
      params: { orderId },   // ✅ send orderId as query param
      ...getToken()          // ✅ include auth headers if needed
    }
  );
  return response.data;
};

const viewOrdersById = async (data: any) => {
  const response = await axios.post(`${API_URL}view-chef-order`,data, getToken());
  return response.data;
};
const viewTracking = async (id: any) => {
    const response = await axios.get(`${API_URL}order-tracking/${id}`, getToken());
    
  return response.data;
};
const getHistory = async (ChefId: any, filterData: any) => {
    const response = await axios.post(`${API_URL}order-history/${ChefId}`, filterData)
  return response.data;
};

const getCategory = async () => {
  const res = await axios.get(`${API_URL}get-category/`);
  return res;
};

const getCuisine = async () => {
  const res = await axios.get(`${API_URL}get-cuisine`);
  return res;
};
const getOrderStatus = async () => {
  const res = await axios.get(`${API_URL}get-order-status`);
  return res;
};
const getUser = async () => {
  const res = await axios.get(`${API_URL}get-user`, getToken());
  return res;
};

 const ViewChatMessage = async (
  order_id: string,
  sender_type: string,
  receiver_type: string
) => {
  try {
    const res = await axios.post(`${API_URL_CHAT}/v1/chat/chatHistory`, {
      order_id,
      sender_type,
      receiver_type,
    });
    return res.data;
  } catch (err) {
    console.error("Error fetching chat history:", err);
    throw err;
  }
};

 const ShowChatHistory = async (data:any) => {
  const res = await axios.post(`${API_URL_CHAT}/v1/chat/chatHistory`, data);
  return res.data;
};

const sentChatMessageApi = async (data: any) => {
    const res = await axios.post(`${API_URL_CHAT}/v1/chat/add`, data);
    return res.data;
};
const updateChatReadingStatus = async (id: any, data: any) => {
    const response = await axios
    .put(`${API_URL}update/${id}`, data);
    return response.data;
};

const createDeliveryQuote = async (data :any) => {
  const res = await axios.post(`${API_URL}create-delivery-quote`, data, getToken());
    return res;
};
export {
  listOrdersData,
  getStatus,
  currentlyAvailable,
  changeStatusOrders,
  getHistory,
  viewOrdersById,
  getCategory,
  getCuisine,
  getOrderStatus,
  getUser,
  viewTracking,
  ViewChatMessage,
  sentChatMessageApi,
  updateChatReadingStatus,
  createDeliveryQuote,
  ShowChatHistory

};
